import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import TracingBase from './TracingBase';

var TracingNoop = /*#__PURE__*/function (_TracingBase) {
  _inherits(TracingNoop, _TracingBase);

  var _super = _createSuper(TracingNoop);

  function TracingNoop() {
    _classCallCheck(this, TracingNoop);

    return _super.apply(this, arguments);
  }

  _createClass(TracingNoop, [{
    key: "init",
    value: function init() {
      return undefined;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return undefined;
    }
  }, {
    key: "setGlobalAttributes",
    value: function setGlobalAttributes() {
      return undefined;
    }
  }, {
    key: "traceError",
    value: function traceError() {
      return undefined;
    }
  }]);

  return TracingNoop;
}(TracingBase);

export { TracingNoop as default };